import cn from 'classnames'
import Checkbox from '../../../customize-button/components/form/Checkbox'
import { t } from '../../../../utilities/translator'
import { AirportItem } from './types'

type Props = {
  airports: AirportItem[];
  group: number;
  groups: { [key: number]: string };
  onCheckboxClick: (airportCode: string) => void;
  onGroupCheckboxClick: (group: number, value: boolean) => void;
  selection: AirportItem[];
}

const GroupList = (props: Props) => {
  const { airports, selection, group, groups, onCheckboxClick, onGroupCheckboxClick } = props;

  return (
    <div className="flex flex-col gap-5">
      <div className={cn('wizard-checkbox-option', { selected: airports.every((dep) => dep.active) })} onClick={() => onGroupCheckboxClick(group, !airports.every((dep) => dep.active))}>
        <Checkbox
          checked={airports.every((dep) => dep.active)}
          label={t('mainFilter.departureGroupAllLabel', { group: t(`mainFilter.${groups[group]}`) })}
          wrapClassNames="pointer-events-none"
        />
      </div>
      {selection.filter((dep: AirportItem) => dep.group_id === group).map((dep: AirportItem) => (
        <div key={dep.id} className={cn('wizard-checkbox-option', { selected: dep.active })} onClick={() => onCheckboxClick(dep.id)}>
          <Checkbox checked={dep.active} label={dep.value} wrapClassNames="pointer-events-none" />
          <div className="ms-auto text-tertiary text-sm font-medium">{dep.id}</div>
        </div>
      ))}
    </div>
  )
}

export default GroupList
